import { render } from "./List.vue?vue&type=template&id=2b74d1df"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=2b74d1df&lang=scss"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__